import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import {
  AcuerdoIndirectoControllerService,
  AcuerdoIndirectoEstadosControllerService,
  DiccionarioElementoDTO, DiccionarioControllerService, 
  AcuerdoIndirectoFilterDTO
} from 'api-rest';
import { SpinnerService } from '../../services/spinner.service';
import { SnackbarService } from '../../services/snackbar.service';
import { IndirectAgreementDialogComponent } from '../indirect-agreement-dialog/indirect-agreement-dialog.component';
import Swal from 'sweetalert2';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { DownloadService } from '../../services/download.service';

@Component({
  selector: 'managers-agreements-indirect-agreement-search',
  templateUrl: './indirect-agreement-search.component.html',
  styleUrls: ['./indirect-agreement-search.component.scss'],
})
export class IndirectAgreementSearchComponent implements OnInit {
  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;

  headArray: any = [
    {
      Head: 'Id',
      FieldName: 'id',
    },
    {
      Head: 'Documento',
      FieldName: 'codigoDocumento',
    },
    {
      Head: 'Razón social',
      FieldName: 'razonSocial',
      Tooltip: true,
    },
    {
      Head: 'Estado',
      FieldName: 'estado',
      renderValue: (item: any) => item?.estado?.descripcion ?? '',
    },
    {
      Head: 'Consentimiento pendiente de validación',
      FieldName: 'anexo',
      renderValue: (item: any) => item?.anexo ? 'Sí' : 'No',
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        { nameButton: 'edit', icon: 'open_in_new', toolTip: 'Editar' },
        {
          nameButton: 'menu',
          array: [
            {
              nameButton: 'generar_acuerdo',
              name: 'Generar acuerdo',
              show: {
                params: 'canAccessUpdateCont',
                accion: 'generar_acuerdo',
              },
            },
            {
              nameButton: 'pasar_completado',
              name: 'Pasar a Completado',
              show: {
                params: 'canAccessComplete',
                accion: 'pasar_completado',
              },
            },
            {
              nameButton: 'dar_baja',
              name: 'Dar de baja',
              show: {
                params: 'canAccessUpdateUnregistered',
                accion: 'dar_baja',
              },
            },
          ],
        },
      ],
      width: '8',
      permanent: true,
    },
  ];
  gridArray: any[] = [];

  estadoArray: any[] = [];

  searchForm: FormGroup;
  flagSearch: boolean = false;
  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  mostrarFiltros: boolean = true;
  orden: DiccionarioElementoDTO[] = [];
  private restoredFiltros: any = null;
  constructor(
    @Inject('environment') private environment: any,
    private acuerdoIndirectoService: AcuerdoIndirectoControllerService,
    private acuerdoIndirectoEstadosService: AcuerdoIndirectoEstadosControllerService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private snackbarService: SnackbarService,
    public spinnerSrv: SpinnerService,
    private router: Router,
    @Inject(DiccionarioControllerService)
    private diccionarioControllerService: DiccionarioControllerService,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService,
    private downloadService: DownloadService

    //Revisar authservice
    // private authService: EmpusaAuthenticationService,
    
  ) {
    this.searchForm = this.formBuilder.group({
      id: [{ value: null, disabled: false }],
      codigo_documento: [{ value: null, disabled: false }],
      razon_social: [{ value: null, disabled: false }],
      estado: [{ value: null, disabled: false }],
      anexo: [{ value: null, disabled: false }],
      cif: [{ value: null, disabled: false }],
      orden: [{ value: null, disabled: false }],
      tipoOrden: [{ value: null, disabled: false }],
    });

    const state = this.router.getCurrentNavigation()?.extras.state ?? window.history.state;
    this.restoredFiltros = state?.filtros ?? null;
  }

  ngOnInit(): void {
    this.getComboEstados();
    this.comboOrden();
    if (this.restoredFiltros) {
      this.searchForm.patchValue(this.restoredFiltros.formValue);
      this.selectedItemsPerPage = this.restoredFiltros.selectedItemsPerPage;
      this.pageSize = this.selectedItemsPerPage;
      this.mostrarFiltros = this.restoredFiltros.mostrarFiltros;
      this.pageNumber = this.restoredFiltros.pageNumber;
      this.obtenerAcuerdosIndirectos();
    } else {
      this.searchData();
    }
  }
  comboOrden() {
    this.diccionarioControllerService
      .listarElementos(['ORDEN_ACUERDO_INDIRECTO_BUSQUEDA'])
      .subscribe((res) => (this.orden = res['ORDEN_ACUERDO_INDIRECTO_BUSQUEDA']));
  }


  renderPage(event: number) {
    this.pageNumber = event;
    this.obtenerAcuerdosIndirectos();
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.searchData();
  }

  checked(item: any) { }

  searchData() {
    this.pageNumber = 1;
    this.obtenerAcuerdosIndirectos();
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    const control = this.searchForm.get(filtro.campo);
    if (!control) {
      return;
    }

    if (filtro.value !== undefined) {
      const current = control.value;

      if (Array.isArray(current)) {
        const updated = current.filter((v) => v !== filtro.value);
        control.setValue(updated.length ? updated : null);
      } else if (current === filtro.value) {
        control.reset();
      }
    } else {
      control.reset();
    }

    //this.searchData();
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const id = this.searchForm.get('id')?.value;
    if (id !== null && id !== undefined && id !== '') {
      filtros.push({ label: `${id}`, campo: 'id' });
    }

    const cif = this.searchForm.get('cif')?.value;
    if (cif) {
      filtros.push({ label: `${cif}`, campo: 'cif' });
    }

    const codigoDocumento = this.searchForm.get('codigo_documento')?.value;
    if (codigoDocumento) {
      filtros.push({ label: `${codigoDocumento}`, campo: 'codigo_documento' });
    }

    const razonSocial = this.searchForm.get('razon_social')?.value;
    if (razonSocial) {
      filtros.push({ label: `${razonSocial}`, campo: 'razon_social' });
    }

    const estados = this.searchForm.get('estado')?.value as any[];
    if (estados?.length) {
      estados.forEach((estId: any) => {
        const found = this.estadoArray.find((e) => e.id === estId.id);
        filtros.push({ label: found?.descripcionCorta ?? String(estId.id), campo: 'estado', value: estId });
      });
    }


    const anexo = this.searchForm.get('anexo')?.value;
    if (anexo !== null && anexo !== undefined) {
      filtros.push({ label: `${anexo ? 'Sí' : 'No'}`, campo: 'anexo' });
    }

    const ordenes = this.searchForm.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
            ? 'Descendente'
            : String(tipoOrden);
      filtros.push({ label: `Tipo orden:${label}`, campo: 'tipoOrden' });
    }

    return filtros;
  }

  obtenerAcuerdosIndirectos() {
    if (this.searchForm.invalid) {
      this.searchForm.markAllAsTouched();
      return;
    }
    this.spinnerSrv.loadingShow();
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    const filtro: AcuerdoIndirectoFilterDTO = {
      id: this.searchForm.get('id')?.value
        ? this.searchForm.get('id')?.value.trim()
        : undefined,
      codigoDocumento: this.searchForm.get('cif')?.value
        ? this.searchForm.get('cif')?.value.trim()
        : undefined,
      razonSocial: this.searchForm.get('razon_social')?.value
        ? this.searchForm.get('razon_social')?.value.trim()
        : undefined,
      estado: this.searchForm.get('estado')?.value ?? undefined,
      anexo: this.searchForm.get('anexo')?.value ?? undefined,
    };
    const orden = this.searchForm.get('orden')?.value;
    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    this.acuerdoIndirectoService
      .findAll3(filtro, { page: page, size: this.pageSize, sort: ['id,desc'] }, orden, tipoOrden)
      .subscribe({
        next: (data: any) => {
          this.spinnerSrv.loadingHide();
          this.flagSearch = (data.datos?.length ?? 0) > 0;
          this.gridArray = this.canAccessAll(data.datos);
          this.recordsTotal = data.paginacion?.totalElements ?? 0;
        },
        error: () => {
          this.spinnerSrv.loadingHide();
          this.snackbarService.showSnackBar(
            'Error obteniendo listado de acuerdos indirectos',
            'error'
          );
        },
      });
  }

  action(item: any) {
    if (item.nameButton == 'edit') {
      this.router.navigate(['/managers-agreements/indirect-agreement-detail'], {
        state: { acuerdo: item, filtros: this.getFiltrosState() },
      });
    } else if (item.nameButton == 'generar_acuerdo') {
      this.spinnerSrv.loadingShow();
      this.acuerdoIndirectoService
        .generarAcuerdo(item.id)
        .subscribe({
          next: () => {
            this.spinnerSrv.loadingHide();
            this.snackbarService.showSnackBar(
              'Acuerdo generado correctamente',
              'success'
            );
            this.searchData();
          },
          error: () => {
            this.spinnerSrv.loadingHide();
            this.snackbarService.showSnackBar(
              'Error generando acuerdo',
              'error'
            );
          },
        });
    } else if (item.nameButton == 'pasar_completado') {
      this.pasarACompletado(item.id);
    } else if (item.nameButton == 'dar_baja') {
      Swal.fire({
        title: '',
        text: '¿Está seguro de dar de baja este acuerdo?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.darBajaAcuerdo(item);
        }
      });
    }
  }

  clearSearcher() {
    this.searchForm.reset();
    this.flagSearch = false;
    this.gridArray = [];
  }

  getFormControl(controlName: string): FormControl {
    return this.searchForm.controls[controlName] as FormControl;
  }

  openModalPreliminaryRegistration(element?: any): void {
    const dialogRef = this.dialog.open(IndirectAgreementDialogComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData();
      }
    });
  }

  canAccessPreliminaryDischarge() {
    return true;
  }

  private getFiltrosState() {
    return {
      formValue: this.searchForm.value,
      pageNumber: this.pageNumber,
      selectedItemsPerPage: this.selectedItemsPerPage,
      mostrarFiltros: this.mostrarFiltros,
    };
  }

  showClearButton(formName: string): boolean {
    return this.searchForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.searchForm.get(formName)?.setValue(null);
  }

  getComboEstados() {
    this.acuerdoIndirectoEstadosService.findAll4().subscribe({
      next: (data: any) => {
        this.estadoArray = data ?? [];
      },
      error: () => { },
    });
  }

  compareEstado(a: any, b: any): boolean {
    return a && b ? a.id === b.id : a === b;
  }

  canAccessAll(list: any) {
    const resultView = this.canViewResource('AI-ENV-GEST') || this.canViewResource('AG-ENV-CONS') || this.canViewResource('AG-ENV-GEST') || this.canViewResource('AI-GESTOR');
    // const resultDelete = this.authService.can('acuerdoIndirecto', 'delete');
    // const resultUpdateCont = this.authService.can(
    //   'acuerdoIndirecto',
    //   'update-contract'
    // );
    // const resultUpdateUnregist = this.authService.can(
    //   'acuerdoIndirecto',
    //   'update-unregister'
    // );

    const listPermission = list.map((objeto: any) => {
      const estadoDelete =
        objeto.estado && [1, 2, 3, 6].includes(objeto.estado.id);
      const estadoUpdateCont =
        objeto.estado && (objeto.estado.id === 2);
      const estadoUpdateUnregist = objeto.estado && objeto.estado.id === 4;

      return {
        ...objeto,
        // canAccessView: resultView,
        // canAccessDelete: resultDelete && estadoDelete,
        canAccessUpdateCont: estadoUpdateCont,
        canAccessComplete: this.canViewResource('AI-ENV-GEST') && objeto.estado?.id === 4,
        canAccessUpdateUnregistered: resultView && objeto.estado && (objeto.estado.id !== 6),
      };
    });

    return listPermission;
  }
  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }
  pasarACompletado(id: number) {
    this.spinnerSrv.loadingShow();
    this.acuerdoIndirectoService.preCompletar(id).subscribe({
      next: (precheck) => {
        this.spinnerSrv.loadingHide();
        if (!precheck?.requiereConfirmacion) {
          this.completarAcuerdo(id);
          return;
        }
        const idExistente = precheck.acuerdoIndirectoIdExistente;
        const detalleId = idExistente ? ` (id ${idExistente})` : '';
        Swal.fire({
          title: '',
          text: `Ya existe un acuerdo indirecto asociado al mismo CIF en estado Completado${detalleId}. Si acepta, se procederá a su baja y se completará el nuevo acuerdo.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
        }).then((result) => {
          if (result.isConfirmed) {
            this.completarAcuerdo(id);
          }
        });
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackbarService.showSnackBar(
          'Error al comprobar los acuerdos existentes',
          'error'
        );
      },
    });
  }

  private completarAcuerdo(id: number) {
    this.spinnerSrv.loadingShow();
    this.acuerdoIndirectoService.completar(id).subscribe({
      next: () => {
        this.spinnerSrv.loadingHide();
        this.snackbarService.showSnackBar(
          'Acuerdo completado correctamente',
          'success'
        );
        this.searchData();
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackbarService.showSnackBar(
          'Error al completar el acuerdo',
          'error'
        );
      },
    });
  }

  darBajaAcuerdo(acuerdo: any) {
     const { nameButton, ...data } = acuerdo ?? {};
     const estadoBaja = this.estadoArray.find((e) => e.id === 6) ?? { id: 6 };
     const payload = { ...data, estado: estadoBaja };
     this.spinnerSrv.loadingShow();
     this.acuerdoIndirectoService.updateById(acuerdo.id, payload).subscribe({
       next: () => {
         this.spinnerSrv.loadingHide();
         this.snackbarService.showSnackBar(
           'Acuerdo dado de baja correctamente',
           'success'
         );
         this.searchData();
       },
       error: () => {
         this.spinnerSrv.loadingHide();
         this.snackbarService.showSnackBar(
           'Error al dar de baja el acuerdo',
           'error'
         );
       },
     });
  }
    private getBackendFilter() {
     const filter = this.searchForm.value;

     const backendFilter: AcuerdoIndirectoFilterDTO = {
      anexo: filter.anexo  ?? undefined,
        codigoDocumento: filter.codigo_documento?.trim() ?? undefined,
       estado: filter.estado ?? undefined,
       razonSocial: filter.razon_social?.trim() ?? undefined,
        
     };  

       const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
  
       const orden = this.searchForm.get('orden')?.value;
       const tipoOrden = this.searchForm.get('tipoOrden')?.value;
       return { backendFilter, page, size: this.pageSize, orden, tipoOrden };
    }
  exportarExcel() {
     const { backendFilter, page, size,orden,tipoOrden } = this.getBackendFilter();
     this.acuerdoIndirectoService
       .exportXlsx4(backendFilter)
       .subscribe((res) => {
         this.downloadService.exportModal();
       });
  }
}
